
import { Injectable } from '@angular/core';
// import { AngularFireMessaging } from '@angular/fire/compat/messaging';
// import { BehaviorSubject, ReplaySubject } from 'rxjs';
// import { getMessaging, onMessage } from 'firebase/messaging';
// import { initializeApp } from 'firebase/app';
// import { MessagePayload } from 'firebase/messaging';
// import { CoreUserProfileService, NotificationProcessService, NotificationService, PushNotification } from '@ftr/owa-core';
// import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FirebaseAppMessagingService {
    // public showNewMessageNotification = new ReplaySubject<boolean>();
    // currentMessage = new BehaviorSubject(null);
    // canAccessFirebaseNotifications: boolean = false;
    // oldToken: string = ''

    // app = initializeApp(environment.coreConfiguration.firebaseConfig);
    // messaging = getMessaging(this.app)

    // constructor(private afMessaging: AngularFireMessaging, private _notificationService: NotificationService, private _notificationProcessService: NotificationProcessService, private _coreProfileService: CoreUserProfileService) {
    // }

    // register() {
    //     this.canAccessFirebaseNotifications = this._coreProfileService?.checkAuthorization("NTF", "CanAccessFirebaseNotifications");
    //     if (this.canAccessFirebaseNotifications) {
    //         this.afMessaging.requestPermission
    //             .subscribe((permission) => {
    //                 if (permission === 'granted') {
    //                     this.afMessaging.getToken
    //                         .subscribe((token) => {
    //                             if (token && token !== this.oldToken) {
    //                                 this.oldToken = token;
    //                                 this._notificationService.registerForPushNotifications("MTP", token, "GFCM").subscribe();
    //                             }
    //                         });
    //                 }
    //             });

    //         this.afMessaging.messages
    //             .subscribe((message: any) => {
    //                 if (message) {
    //                     this.currentMessage.next(message);
    //                 }

    //                 if (message.data) {
    //                     let notification = message.data;
    //                     let notificationPayload = JSON.parse(notification.payload);
    //                     let pushNotification = message.data as PushNotification;
    //                     pushNotification.payload = notificationPayload;
    //                     this._notificationProcessService.addPushNotificationToQueue(pushNotification)
    //                     this.showNewMessageNotification.next(true);
    //                 }
    //             });


    //         onMessage(this.messaging, (payload: MessagePayload) => {
    //             if (payload.data) {
    //                 let notification = payload.data;
    //                 let notificationContent = JSON.parse(notification.payload);
    //                 let notificationPayload = JSON.parse(notificationContent.payload);
    //                 let pushNotification = notificationContent as PushNotification;
    //                 pushNotification.payload = notificationPayload;
    //                 this._notificationProcessService.addPushNotificationToQueue(pushNotification)
    //                 this.showNewMessageNotification.next(true);
    //             }
    //         });
    //     }
    // }
}
